import ReactorWebSocket from './websocket.js';

export var sharedReactorWebsocket = new ReactorWebSocket();

//export const API_VERSION = "1.19";   // first Vue based participant app (same version exists in old app as well as 1.20-1.22)
//export const API_VERSION = "1.23";     // NA-2021-REL2, html based homscreen customization
//export const API_VERSION = "1.26";     // ICJ, DeviceLeaveProjectResponse as response to DeviceLeaveProjectAction
//export const API_VERSION = "1.27";     // Ranking question type
//export const API_VERSION = "1.28";     // HostAnnouncements
export const API_VERSION = "1.29"; // DeviceGuestCapacityList


//////////////////
// WEBPACK FOOTER
// ../ReactorJSCore/dist/reactor.js
// module id = null
// module chunks = 